import React from "react"

import { CircularProgress } from "../../mui-reexports"

export const LoaderSpinner = ({ position, size = 40 }) => {
  return (
    <div style={{ textAlign: position }}>
      <CircularProgress size={size} />
    </div>
  )
}
